import { render, staticRenderFns } from "./orderTabContent.vue?vue&type=template&id=1bf8d47e&scoped=true&"
import script from "./orderTabContent.vue?vue&type=script&lang=js&"
export * from "./orderTabContent.vue?vue&type=script&lang=js&"
import style0 from "./orderTabContent.vue?vue&type=style&index=0&id=1bf8d47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8d47e",
  null
  
)

export default component.exports